export default `
  .manifold-text-section {
    .manifold-rte-center {
      text-align: center;
      list-style-position: inside;
    }
    .manifold-rte-right {
      text-align: right;
      list-style-position: inside;
    }
    .manifold-rte-justify {
      text-align: justify;
    }
    .manifold-rte-left {
      text-align: left;
    }

    img.manifold-rte-right {
      margin-inline: auto 0;
    }
    img.manifold-rte-center {
      margin-inline: auto;
    }
  }
`;
